import React, { useEffect, useState, useCallback } from "react";
import "../../Styles/yellowcalf.css/Wallet_Sales_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import userImg from "../../images/user.png";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function WalletAGING() {
  const customer_currency = (localStorage.getItem("customer_currency") || "").replace(/"/g, "");
  const [students, setStudents] = useState([]);
  const [agingData, setAgingData] = useState([]);
  const [loading, setLoading] = useState(false);
  // Keeping state names but leaving them empty by default
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("2026-03-01");
  const [selectedStudent, setSelectedStudent] = useState("");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        // Using due_date as the primary filter
        due_date: endDate || "",
        // student_id: selectedStudent || ""    "customer_id": 1005,
      };

      const response = await simplePostCall(
        ApiConfig.InvoiceagingReport,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        // response.students is used for the dropdown list
        setStudents(response.students || []);
        // response.excelArray contains the calculated aging amounts
        setAgingData(response.excelArray || []);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  }, [endDate, selectedStudent]); // startDate removed from dependencies as it's not in payload

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleClearFilters = () => {
    setStartDate("");
    setEndDate("");
    setSelectedStudent("");
  };

  return (
    <div
      className="cashless_balance_report-container"
      style={{ paddingTop: "25px" }}
    >
      <div className="cashless_balance_report-row">
        <div className="cashless_balance_report-col">
          <div className="cashless_balance_report-panel">
            <div className="cashless_balance_report-panel-body">
              <div className="cashless_balance_report-header">
                <h3 className="cashless_balance_report-title">
                  Invoice Aging Report
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cashless_balance_report-row">
        <div className="cashless_balance_report-col">
          <div className="cashless_balance_report-panel">
            <div className="cashless_balance_report-panel-body">
              <div className="cashless_balance_report-table-responsive">
                <table className="cashless_balance_report-table">
                  <thead>
                    <tr className="cashless_balance_report-filters">
                      <td colSpan="4">
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                            marginBottom: "15px"
                          }}
                        >
                          {/* <select 
                                                        className="cashless_balance_report-input"
                                                        value={selectedStudent}
                                                        onChange={(e) => setSelectedStudent(e.target.value)}
                                                        style={{ width: "200px" }}
                                                    >
                                                        <option value="">All Students</option>
                                                        {students.map(std => (
                                                            <option key={std.student_id} value={std.student_id}>
                                                                {std.student_name}
                                                            </option>
                                                        ))}
                                                    </select> */}

                          <label style={{ fontSize: "14px", color: "#1f2937", fontWeight: 600, marginRight: "8px", whiteSpace: "nowrap" }}>
                            Due Date:
                          </label>
                          <input
                            type="date"
                            className="cashless_balance_report-input"
                            value={endDate}
                            onChange={(e) => setEndDate(e.target.value)}
                          />
                          <button
                          style={{ whiteSpace: "nowrap", backgroundColor: "var(--color-primary)", border: "none"}}
                            className="btn btn-Primary text-white"
                            onClick={handleClearFilters}
                          >
                            Clear
                          </button>
                        </div>
                      </td>
                      <td colSpan="4"></td>
                    </tr>
                    <tr>
                      <th style={{ textAlign: "center" }}>#</th>
                      <th style={{ textAlign: "center" }}>Student</th>
                      <th style={{ textAlign: "center" }}>Adm No.</th>
                      <th style={{ textAlign: "center" }}>0-30 Days</th>
                      <th style={{ textAlign: "center" }}>31-60 Days</th>
                      <th style={{ textAlign: "center" }}>61-90 Days</th>
                      <th style={{ textAlign: "center" }}>90+ Days</th>
                      <th style={{ textAlign: "center" }}>Total Due</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                       <tr>
                        <td colSpan="8" style={{ textAlign: "center", padding: "7px" }}>
                          <div className="text-center">
                              <ScaleLoader color="#F4BB44" /> 
                            </div>
                        </td>
                      </tr>
                    ) : agingData.length > 0 ? (
                      agingData.map((item, index) => {
                        const studentInfo = students.find(
                          (s) =>
                            s.student_admission_num ===
                            item.student_admission_num,
                        );
                        return (
                          <tr key={index}>
                            <td style={{ textAlign: "center" }}>{index + 1}</td>
                            <td style={{ textAlign: "center" }}>
                              {studentInfo ? studentInfo.student_name : "---"}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {item.student_admission_num}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {customer_currency} {formatNumber(item.zero_to_thirtydays)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {customer_currency} {formatNumber(item.thirtyone_to_sixtydays)}
                            </td>
                            <td style={{ textAlign: "center" }}>
                              {customer_currency} {formatNumber(item.sixtyone_to_ninetydays)}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                color: "#f5365c",
                                fontWeight: "bold",
                              }}
                            >
                              {customer_currency} {formatNumber(item.nietyPlus)}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                fontWeight: "bold",
                                color: "#2dce89",
                              }}
                            >
                              {customer_currency} {formatNumber(item.totalSum)}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan="8"
                          style={{ textAlign: "center", padding: "20px" }}
                        >
                          No aging records found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletAGING;
